export const DEFAULT_VAT_RATE = 23;
export const DEFAULT_LEGAL_INFO = "Art. 113 ust. 1";
